module.exports = __webpack_public_path__ + "static/Kiran-Kumar-b14e00bde96b6e06ff3f1cf0701c3dec.png";